import styled from 'styled-components';

import { searchBarBoxShadow, colorGrey400 } from 'constants/colors';
import { FERRET_ID } from './contants';

export const Wrapper = styled.div<{ backgroundColor?: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor || colorGrey400};
`;

export const FerretWrapper = styled.div<{ margin: string; isMobile?: boolean }>`
  box-shadow: ${searchBarBoxShadow};
  margin-top: ${props => props.margin};
  border-radius: 8px;

  form[id='${FERRET_ID}'] {
    padding: ${({ isMobile }) => (isMobile ? '0' : '28px 16px')};
  }
`;
